import * as React from "react";
import * as ReactDOM from "react-dom";
import "rsuite/dist/styles/rsuite-default.css";
import "asset/scss/index.scss";
import { FlexboxGrid, Col } from "rsuite";
import styled from "styled-components";
import { Config, Endpoints } from "configs/index";
import { Language } from "commons/Language";
import Recover from "./recover";
import { EmailSent } from "./sent";
import ResetPassword from "./reset";
import { SuccessPass } from "./success";
import { Notification } from "commons/Notification";
import Axios from "axios";

const img = Config.BASE_URL + "assets/img/osdepym/hero.jpg";
const logo = Config.BASE_URL + "assets/img/osdepym/logoOsdepym.jpg";

const Hero = styled.section<any>`
	width: calc(100vw - 500px);
	height: 100vh;
	background-image: url(${img});
	background-position: center;
	background-size: cover;
`;
const SideContent = styled.section.attrs(() => ({
	className: "p-l-50 p-r-50 p-t-50 sm-p-l-15 sm-p-r-15 sm-p-t-40",
}))`
	width: 500px;
	height: 100vh;
	background-color: white;
`;
interface IState {
	token: string | undefined;
	emailSent: boolean;
	success: boolean;
	user: { email: string; name: string };
}

interface IProps {
	token?: string | undefined;
}

class Layout extends React.Component<IProps, IState> {
	constructor(props: any) {
		super(props);
		this.state = {
			token: undefined,
			emailSent: false,
			success: false,
			user: { email: "", name: "" },
		};
	}

	setEmailSent = () => {
		//console.log("setEmailSent");
		this.setState({ emailSent: true });
	};

	setPasswordChanged = () => {
		//console.log("setPasswordChanged");
		this.setState({ success: true });
	};

	componentDidMount() {
		const { token } = this.props;
		//console.log("token:", this.props.token);
		this.setState({ token: token }, () => token && this.getUserData());
	}

	getUserData() {
		const { token } = this.state;
		this.getRequest(
			Endpoints.GET_TOKEN_DATA.replace("{token}", token!),
			{},
			this.success,
			this.error,
			this.always
		);
	}

	getRequest(
		pathRelative: string,
		data: any,
		success?: any,
		error?: any,
		always?: any
	) {
		const CancelToken = Axios.CancelToken;
		const source = CancelToken.source();

		Axios.get(Config.END_POINT + pathRelative, {
			params: data,
			cancelToken: source.token,
		})
			.then(function (response) {
				if (success) {
					success(response);
				}
			})
			.catch(function (errors) {
				if (errors.response && error) {
					error(errors);
				}
			})
			.then(function () {
				if (always) {
					always();
				}
			});

		return source;
	}

	success = (response: any) => {
		const { email, name } = response.data.data;
		//console.log("response:", response.data.data);
		this.setState({ user: { email: email, name: name } });
	};

	error = (error: any) => {
		Notification.errorObject(error);
	};

	always = () => {
		this.setState(
			(prevState) => ({
				...prevState,
				spinner: false,
			}) /* ,
			() => console.log(this.state) */
		);
	};

	render() {
		const { token, emailSent, success, user } = this.state;
		return (
			<div className="d-flex">
				<Hero></Hero>
				<SideContent>
					<div className="show-grid">
						<FlexboxGrid>
							<FlexboxGrid.Item componentClass={Col} colspan={24}>
								<img
									src={logo}
									alt="Logo osdepym"
									className="brand mt-4"
									width="140"
								></img>
							</FlexboxGrid.Item>
							<FlexboxGrid.Item
								className="mt-3"
								componentClass={Col}
								colspan={24}
							>
								{success ? (
									<SuccessPass></SuccessPass>
								) : token ? (
									<ResetPassword
										user={user}
										token={token}
										passwordChanged={this.setPasswordChanged}
									></ResetPassword>
								) : emailSent ? (
									<EmailSent></EmailSent>
								) : (
									<Recover setEmail={this.setEmailSent}></Recover>
								)}
							</FlexboxGrid.Item>
						</FlexboxGrid>
					</div>
				</SideContent>
			</div>
		);
	}
}

let reset_pass_container: any = document.getElementById(
	"container-restablecer-view"
);
let token: string = String(reset_pass_container.dataset.token);

ReactDOM.render(<Layout token={token} />, reset_pass_container);
